module.exports = __webpack_public_path__ + "img/744-cc5cf9.png";